export default __webpack_public_path__ + "static/media/img_capa_book.130819a9.svg";